export const PRODUCT_CROWN_CAP = {
  label: 'Crown Cap',
  value: 'PRODUCT_CROWN_CAP'
};
